import Form from "./Form/Form";
import "./Body.css";
export default function Body() {
  return (
    <div className="Body app-wrapper">
      <Form />
    </div>
  );
}
